import List from "@/views/MGT/Organizational/List";
import OSTree from "@/views/MGT/Organizational/OSTree";
import UserJoin from "@/views/MGT/Organizational/UserJoin";
import UserDetail from "@/views/MGT/Organizational/UserDetail";
import { initialInvite } from "@/service/structure";
import { mapState } from "vuex";
export default {
  name: "Structure",
  components: {
    List,
    OSTree,
    UserJoin,
    UserDetail
  },
  data() {
    return {
      loading: false,
      search: {
        value: ""
      },
      org: {
        orgId: "",
        actionValue: "1" // '1'：代表列表, '2': '新增/编辑成员', '3': 成员详情
      },
      user: {
        item: null
      }
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapState({
      language: state => state.app.language
    }),
    showList() {
      return this.org.actionValue === "1";
    },
    showUserMessage() {
      return this.org.actionValue === "2";
    },
    showUserDetail() {
      return this.org.actionValue === "3";
    }
  },
  watch: {
    "org.actionValue": function (val, beforValu) {
      if (val === "1") {
        if (this.user.item) {
          this.user.item = null;
        }
        if (beforValu === "2") {
          this.$refs["list"].searchByValue(this.search.value);
        }
      }
    },
    "search.value": function (val) {
      if (!val) {
        this.onSearchList();
      }
    }
  },
  methods: {
    clearSearchValue() {
      this.search.value = "";
    },
    /*
     ** 搜索部门成员
     */
    onSearchList() {
      this.changeAction("1");
      this.$refs["list"].searchByValue(this.search.value);
    },
    changeOrg(org) {
      this.org = org;
    },
    onSearchByUser() {
      this.$refs["list"].searchUser();
    },
    changeUser(item) {
      this.user.item = {
        ...item
      };
      this.changeAction("2");
    },
    changeDetail(item) {
      this.user.item = {
        ...item
      };
      this.changeAction("3");
    },
    /*
     ** 短信邀请
     */
    async initialInviteSms({
      userId
    }) {
      this.loading = true;
      const params = {
        userIds: userId
      };
      let res = await initialInvite(params);
      if (res.data && res.data.result === 0) {
        this.loading = false;
        this.$Message.success($t("b65a734", "发送成功"));
      } else {
        this.loading = false;
      }
    },
    /*
     ** 打开弹窗
     */
    openModal() {
      this.$refs["STree"].openModal("addManage");
    },
    changeAction(key, search) {
      let org = {
        ...this.org,
        ...{
          actionValue: key
        }
      };
      if (search) {
        this.onSearchByUser();
      }
      this.changeOrg(org);
    }
  }
};